import cx from 'classnames';

import { Card } from '~/components/Card';
import Typography from '~/components/Typography';

type Props = React.PropsWithChildren<{
  title: string;
  description?: React.ReactNode;
  scrollToId?: string;
  titleAction?: React.ReactNode;
  className?: string;
  maxWidthClassName?: string;
}>;

const Section: React.FC<Props> = ({
  title,
  titleAction,
  description,
  scrollToId,
  className,
  children,
  maxWidthClassName = 'max-w-2xl',
}) => {
  return (
    <Card id={scrollToId} className={cx('w-full p-8', className, maxWidthClassName)}>
      <div className="mb-6 space-y-2">
        <div className="flex justify-between">
          <Typography weight="medium" size="lg">
            {title}
          </Typography>
          {titleAction && titleAction}
        </div>
        {description && (
          <Typography size="sm" className="text-gray-700">
            {description}
          </Typography>
        )}
      </div>
      {children}
    </Card>
  );
};

export default Section;
